
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/debug.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-debug-demo-debug"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/debug.en-US.md?type=demo')
};